import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { map, take } from 'rxjs';
import { AppService } from '../services/app.service';

export const authGuardInvoiceGuard: CanActivateFn = (route, state) => {
  const appSrv = inject(AppService);
  const router = inject(Router);

  const data = JSON.parse(localStorage.getItem('data') || '{}');
  if (data.PurchaseType === 'Credit') {
    router.navigate(['app/dashboard']);
    return false;
  }

  return appSrv.checkStatuInvoiceModule().pipe(
    take(1),
    map(result => {
      if (result.invoiceModuleActive) {
        return true;
      } else {
        router.navigate(['app/dashboard']);
        return false;
      }
    })
  );
};
